module.exports = __webpack_public_path__ + "static/media/ky.cfa62ef5.svg";